import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { imageBlockSrc, type ImageContentBlock } from "@/lib/chat";

interface ImageLightboxProps {
	image: ImageContentBlock;
	onClose: () => void;
}

/**
 * 画像を原寸表示する全画面のライトボックス。背景クリックか Escape で閉じる。
 * チャット履歴のブロックは paint containment を持ち fixed 配置を閉じ込めるため、body へ出す。
 */
export function ImageLightbox({ image, onClose }: ImageLightboxProps) {
	const ref = useRef<HTMLDivElement>(null);

	useEffect(() => {
		ref.current?.focus();
	}, []);

	return createPortal(
		<div
			ref={ref}
			tabIndex={-1}
			data-testid="message-image-lightbox"
			onClick={(e) => {
				if (e.target === e.currentTarget) onClose();
			}}
			onKeyDown={(e) => {
				if (e.key === "Escape") onClose();
			}}
			onWheel={(e) => e.preventDefault()}
			style={{
				position: "fixed",
				inset: 0,
				zIndex: 500,
				background: "var(--scrim)",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				cursor: "zoom-out",
				outline: "none",
			}}
		>
			<img
				src={imageBlockSrc(image)}
				style={{
					maxWidth: "90vw",
					maxHeight: "90vh",
					objectFit: "contain",
					borderRadius: "var(--radius-4)",
					boxShadow: "var(--shadow-ring)",
					cursor: "default",
				}}
			/>
		</div>,
		document.body,
	);
}
